<template>
  <div
    class="levelIcon"
    v-if="$store.state.gameType == '3' && $store.state.integralFlag"
  >
    <div class="task_user_level_text_icon" :class="rankClass">{{ level }}</div>
  </div>
</template>
<script>
export default {
  name: 'levelIcon',
  props: {
    level: {
      type: Number,
      default: 0
    }
  },
  watch: {
    level(n, o) {
      this.getLevel();
    }
  },
  data() {
    return {
      rankClass: 'rank1' // rank1 rank2 rank3 rank4
    };
  },
  mounted() {
    this.getLevel();
  },
  methods: {
    getLevel() {
      if (this.level >= 20) {
        this.rankClass = 'rank6';
      } else if (this.level >= 17) {
        this.rankClass = 'rank5';
      } else if (this.level >= 13) {
        this.rankClass = 'rank4';
      } else if (this.level >= 9) {
        this.rankClass = 'rank3';
      } else if (this.level >= 5) {
        this.rankClass = 'rank2';
      } else {
        this.rankClass = 'rank1';
      }
    }
  }
};
</script>
<style></style>